import FormikSelect from './Select';
export default FormikSelect;



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/Select/index.tsx
// module id = 1478
// module chunks = 0